<!-- 新建活码 -->
<template>
  <div class="container">
    <el-dialog
      :title="this.ceTitle"
      :visible.sync="show"
      :modal-append-to-body="false"
      width="850px"
      style="'margin-top:15vh'"
      :close-on-click-modal="false"
      :before-close="cancelHandle"
    >
      <el-form
        :model="codeForm"
        ref="codeForm"
        :rules="rules"
        label-width="4em"
        class="xForm"
        center
      >
        <el-form-item label="类型" prop="qrType">
          <template #label>
            <div class="my-label">类型</div>
          </template>
          <el-radio-group
            v-model="codeForm.qrType"
            @change="typeChange"
            :disabled="onlySee"
          >
            <el-radio label="1">批量单人</el-radio>
            <el-radio label="0">单人</el-radio>
            <el-radio label="2">多人</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="使用人员" prop="userList" class="el-tags-wrap">
          <el-tag
            style="margin-right:4px"
            v-for="item in userMembenNames"
            :key="item.id"
            :closable="!onlySee"
            type="small"
            @close="delSelectedHandle(item)"
          >
            {{ item.name }}
          </el-tag>
          <el-button
            v-if="!onlySee"
            type="text"
            @click="clickAddMember()"
            class="tags-btn"
            >{{ userMenberList.length != 0 ? "修改" : "添加" }}</el-button
          >
        </el-form-item>
        <el-form-item label="添加设置" prop="skipVerify">
          <el-checkbox :disabled="onlySee" v-model="codeForm.skipVerify"
            >客户添加时无需确认自动成为好友</el-checkbox
          >
        </el-form-item>
        <el-form-item label="使用场景" prop="sceneName">
          <el-input
            :disabled="onlySee"
            clearable
            v-model="codeForm.sceneName"
            autocomplete="off"
            size="small"
            maxlength="30"
            show-word-limit
            style="width: 280px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="扫码标签"
          prop="tagIdList"
          class="el-tags-wrap"
          v-if="!onlySee"
        >
          <el-tag
            type="small"
            closable
            v-for="item in selecteTagsList"
            :key="item.tagId"
            @close="delSelectedTags(item.tagId)"
            >{{ item.tagName }}</el-tag
          >
          <el-button class="tags-btn" type="text" @click="addTagsHandle()"
            >添加</el-button
          >
        </el-form-item>
        <el-form-item
          label="欢迎语"
          prop="welcomeContent"
          class="welcome-form-item"
        >
          <MyUpload
            ref="myUpload"
            v-if="editData == null"
            :myType="4"
            @receiveParam="receiveParam"
          />
          <MyUploadDetail v-else :myType="4" :upLoadData="upLoadData" />
          <!-- <el-input
                type="textarea"
                clearable
                size="small"
                maxlength="200"
                :autosize="{ minRows: 2, maxRows: 4}"
                show-word-limit
                :disabled="welcomeAreaEditable"
                v-model="codeForm.welcomeContent"
                class="welcome-input"
                @input="welInputHandle"
            >
            </el-input>
            <i class="el-icon-circle-close welcome-clear" @click="clearWelcomeHandle()" v-show="welcomeClearBtnShow"></i>
            <el-button type="primary" size="mini"  icon="el-icon-plus" style="margin-top:15px" @click="addWelcomeHandle()">选择模板</el-button> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!onlySee">
        <el-button
          size="small"
          @click.stop="cancelHandle()"
          style="margin-right:20px"
          >返 回</el-button
        >
        <el-button
          type="primary"
          size="small"
          :disabled="confirmDisable"
          @click="confirmHandle()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 添加人员树 -->
    <!-- <AddMemberView 
            :title="title"
            :dialogVisibleTree="dialogVisibleTree" 
            :currentSelectMember='userMenberList' 
            :codeType="this.codeForm.qrType"
            @closeTree='closeTree' 
            @clickSubmitTree='clickSubmitTree'
        ></AddMemberView> -->
    <StaffTree
      ref="myStaffTree1"
      :title="title"
      :dialogVisibleTree="dialogVisibleTree1"
      :currentSelectMember="userMenberList"
      @closeTree="closeTree"
      @clickSubmitTree="clickSubmitTree"
    ></StaffTree>
    <StaffTreeTwo
      ref="myStaffTree0"
      :title="title"
      :dialogVisibleTree="dialogVisibleTree0"
      :currentSelectMember="userMenberList"
      :treeType="2"
      @closeTree="closeTree"
      @clickSubmitTree="clickSubmitTree"
      oldSelectTitle=""
    ></StaffTreeTwo>

    <StaffTree
      ref="myStaffTree2"
      :title="title"
      :dialogVisibleTree="dialogVisibleTree2"
      :currentSelectMember="userMenberList"
      @closeTree="closeTree"
      @clickSubmitTree="clickSubmitTree"
    ></StaffTree>

    <AddTagsDia
      :tagsDislogVisible="tagsDislogVisible"
      :selecteTagsList="selecteTagsList"
      @tagsCloseHandle="tagsCloseHandle"
      @tagsConfirmHandle="tagsConfirmHandle"
    ></AddTagsDia>
    <!-- <WelcomeTempDia
            :welcomeDislogVisible="welcomeDislogVisible"
            @welcomeCloseHandle="welcomeCloseHandle"
            @welcomeConfirmHandle="welcomeConfirmHandle"
        ></WelcomeTempDia> -->
  </div>
</template>
<script>
import {
  createActiveCode,
  editActiveCode,
  getActivityDepartStaff,
  getCodeTags,
} from "@/api/activeCode/activeCode.js";
import { getOrganization } from "@/api/staffTree/staffTree.js";
import MyUpload from "@/views/mass/SOP/components/myUpload.vue";
import MyUploadDetail from "@/views/mass/SOP/components/myupLoadDetail.vue";
import StaffTree from "@/components/staffTree/staffTree.vue";

import StaffTreeTwo from "@/components/staffTree/staffTreeTwo.vue";
import AddMemberView from "../components/addMember.vue";
import AddTagsDia from "./ScanTags.vue";
import WelcomeTempDia from "./WelcomeDia.vue";
export default {
  name: "ActiveCodeCreate",
  props: ["activeCodeVisible", "ceTitle", "editData"],
  components: {
    StaffTreeTwo,
    StaffTree,
    AddTagsDia,
    WelcomeTempDia,
    MyUpload,
    MyUploadDetail,
  },
  data() {
    return {
      title: "选择使用成员",
      show: false,
      //活码form
      codeForm: {
        qrType: "1", //活动二维码类型 0:单人 1:批量单人   2:多人
        userList: [], // //使用成员集合  {"userId":"MaiJianHong",  //使用成员userId  "userName":"麦剑鸿" //使用成员名称}
        skipVerify: true, //客户添加时无需确认自动成为好友  0:勾选  1:不勾选
        sceneName: "", //使用场景
        tagIdList: [], //标签id集合
        welcomeId: null, //欢迎语id（从模板中选id不为null, 没从模板中选id为null）
        welcomeContent: "", //欢迎语
        resourceVos: [],
        linkVo: null,
        appletVo: null,
      },
      markForm: {},
      qrType: null,
      userMenberList: [], //添加的使用人员
      userMembenNames: [], //添加的使用人员名字
      dialogVisibleTree1: false, //打开使用人员树 批量单人
      dialogVisibleTree0: false, //打开使用人员树 单人
      dialogVisibleTree2: false, //打开使用人员树 多人

      tagsDislogVisible: false, //扫码标签弹窗
      selecteTagsList: [], //选中的标签集合
      // welcomeDislogVisible:false,//欢迎语模板弹窗
      // welcomeAreaEditable:false,//欢迎语是否可编辑  true-不可编辑  false-可编辑
      // welcomeClearBtnShow:false,
      markLength: 0,
      allStaff: [], //所有员工数据
      upLoadData: {
        content: "",
        resourceVos: [],
        sopLink: null,
        appletVo: null,
      },
      rules: {
        qrType: [
          { required: true, message: "必须选择一个类型", trigger: "blur" },
        ],
        userList: [
          {
            type: "array",
            required: true,
            message: "请先选择使用人员再生成活码",
            trigger: "change",
          },
        ],
      },
      onlySee: false, //编辑的时候  即详情  仅可查看
    };
  },
  async created() {
    // let tree1 = this.$store.state.tagsView.tree1;
    // if (tree1 && tree1.length != 0) {
    //   this.allStaff = tree1.empList;
    // } else {
    // await this.getDepartStaff();
    // }
  },
  computed: {
    confirmDisable() {
      return this.codeForm.userList.length > 0 ? false : true;
    },
  },
  watch: {
    activeCodeVisible(val) {
      this.show = val;
      this.markForm = JSON.parse(JSON.stringify(this.codeForm));
      if (val && this.editData) {
        //获取活码的扫码标签
        this.getCodeTags(this.editData.qrId);
        for (let key in this.codeForm) {
          switch (key) {
            case "qrType":
              this.codeForm[key] = this.editData[key].toString();
              this.markForm[key] = this.editData[key].toString();
              break;
            case "userList":
              //已设置的使用人员的id集合
              let userIds = this.editData.configList.map((v) => {
                this.codeForm.userList.push({
                  userId: v.userId,
                  userName: v.userName,
                });
                this.markForm.userList.push({
                  userId: v.userId,
                  userName: v.userName,
                });
                return v.userId;
              });
              this.userMenberList = this.allStaff.filter((v) => {
                return userIds.includes(v.userId) == true;
              });
              this.getUsersNameData(this.userMenberList);
              break;
            case "skipVerify":
              this.codeForm[key] = !this.editData[key];
              this.markForm[key] = !this.editData[key];
              break;
            case "linkVo":
              this.codeForm[key] = this.editData.sopLink;
              this.markForm[key] = this.editData.sopLink;
              break;
            default:
              this.codeForm[key] = this.editData[key];
              this.markForm[key] = this.editData[key];
              break;
          }
        }
        let obj = {
          content: this.codeForm.welcomeContent,
          resourceVos: this.codeForm.resourceVos,
          sopLink: this.codeForm.linkVo,
          appletVo: this.codeForm.appletVo,
        };
        this.upLoadData = JSON.parse(JSON.stringify(obj));
        console.log("this.upLoadData", this.upLoadData);
        this.qrType = this.codeForm.qrType;
      } else if (val && this.editData == null) {
        this.$nextTick(() => {
          this.$refs.myUpload.initParams();
        });
      }
    },
    ceTitle(val) {
      if (val == "活码详情") {
        this.onlySee = true;
      } else {
        this.onlySee = false;
      }
    },
  },

  methods: {
    //获取活码的扫码标签
    getCodeTags(editId) {
      getCodeTags(editId, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            this.selecteTagsList = res.data;
          }
        })
        .catch((err) => {});
    },
    //获取员工&部门
    async getDepartStaff() {
      let params = {
        mark: 2,
      };
      await getOrganization(params, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            this.$store.dispatch("tagsView/setTree1", res.data);
            this.allStaff = res.data.empList;
          }
        })
        .catch((err) => {});
    },
    //获取显示的人员数据
    getUsersNameData(data) {
      let memberList = data;
      this.userMembenNames = [];
      memberList.map((v) => {
        this.userMembenNames.push({
          treeId: v.id, //树id
          id: v.userId ? v.userId : v.departmentId,
          name: v.userName ? v.userName : v.departmentName,
          type: v.userId ? "per" : "depart",
        });
      });
      this.userMembenNames = this.getArrSet(this.userMembenNames, "id");
      if (this.userMembenNames.length == 0) {
        this.codeForm.userList = [];
        this.markForm.userList = [];
      }
    },
    //添加使用人员
    async clickAddMember() {
      console.log(1, this.userMenberList);
      await this.getDepartStaff();
      // if(this.codeForm.qrType==2){

      //   this.dialogVisibleTree1 = true
      // }else{

      this["dialogVisibleTree" + this.codeForm.qrType] = true;
      // this.dialogVisibleTree = true;
      // }
    },
    //关闭树
    closeTree() {
      this["dialogVisibleTree" + this.codeForm.qrType] = false;
      // this.dialogVisibleTree = false;
    },
    //删除选中的成员数据
    delSelectedHandle(data) {
      this.$refs["myStaffTree" + this.codeForm.qrType].clickCurrrntFn(
        data,
        true
      );
    },
    // 接受上传组件返回的参数
    receiveParam(obj) {
      console.log("obj", obj);
      // obj = {
      //   flag: true/false
      //   content: '',
      //   resourceVos: '',
      //   linkVo: {}
      // }
      this.myUploadFlag = obj.flag;
      this.codeForm.welcomeContent = obj.content;
      this.codeForm.resourceVos = obj.resourceVos;
      this.codeForm.linkVo = obj.linkVo;
     this.codeForm.appletVo = obj.appletVo ? obj.appletVo : null;
    },
    //类型切换
    typeChange(val) {
      if (this.editData != null) {
        this.codeForm.qrType = this.qrType;
        this.$message.warning("活码类型不可修改");
      } else {
        if (val == 0 && this.codeForm.userList.length > 1) {
          this.$message.warning("单人活码类型仅可选择单个员工");
          this.$nextTick(() => {
            this.codeForm.qrType = "1";
          });
        }
      }
    },
    //对象数组去重(根据userId去重)
    getArrSet(Arr, id) {
      var obj = {};
      const arrays = Arr.reduce((setArr, item) => {
        obj[item[id]] ? "" : (obj[item[id]] = true && setArr.push(item));
        return setArr;
      }, []);
      return arrays;
    },
    //使用人员树确认回调
    clickSubmitTree(val) {
      this.userMenberList = val.currentMember;
      this.codeForm.userList = [];
      this.userMembenNames = val.currentIdName;
      // this.getUsersNameData(this.userMenberList)
      let arr = JSON.parse(JSON.stringify(val.sendArray));
      arr.forEach((item) => {
        let obj = {
          userId: item.userId,
          userName: item.userName,
        };
        this.codeForm.userList.push(obj);
      });
      this.closeTree();
    },
    //添加扫码标签
    addTagsHandle() {
      this.tagsDislogVisible = true;
    },
    //扫码标签关闭回调
    tagsCloseHandle() {
      this.tagsDislogVisible = false;
    },
    //扫码标签确认回调
    tagsConfirmHandle(callBackVal) {
      this.selecteTagsList = callBackVal;
      this.tagsDislogVisible = false;
    },
    //删除选中的标签
    delSelectedTags(tagId) {
      this.selecteTagsList = this.selecteTagsList.filter((v) => {
        return v.tagId != tagId;
      });
    },
    //选择欢迎语模板
    // addWelcomeHandle(){
    //     this.welcomeDislogVisible = true
    // },
    //关闭欢迎语模板回调
    // welcomeCloseHandle(){
    //     this.welcomeDislogVisible = false
    // },
    //选择欢迎语模板 确定回调
    // welcomeConfirmHandle(val){
    //     if(!!val){
    //         this.welcomeAreaEditable = true
    //         this.codeForm.welcomeContent = val.welcomeContent
    //         this.codeForm.welcomeId = val.welcomeId
    //         this.welcomeClearBtnShow = true
    //     }
    //     this.welcomeDislogVisible = false
    // },
    //清空欢迎语
    // clearWelcomeHandle(){
    //     this.welcomeAreaEditable = false
    //     this.codeForm.welcomeContent = ""
    //     this.codeForm.welcomeId = null
    //     this.welcomeClearBtnShow = false
    // },
    // welInputHandle(val){
    //     if(!!val){
    //         this.welcomeClearBtnShow = true
    //     }else{
    //         this.welcomeClearBtnShow = false
    //     }
    // },
    //取消 叉叉
    cancelHandle(done) {
      if (JSON.stringify(this.codeForm) != JSON.stringify(this.markForm)) {
        this.$confirm("", "", {
          confirmButtonText: "离开此页",
          cancelButtonText: "留在此页",
          message: `<div style="font-size:15px;">修改的内容尚未保存，确定离开此页？</div>`,
          dangerouslyUseHTMLString: true,
          iconClass: "el-icon-warning",
          customClass: "delete-messege",
          center: true,
        })
          .then(() => {
            this.resetForm();
            this.$emit("createCancelHandle");
            done();
          })
          .catch(() => {});
      } else {
        this.resetForm();
        this.$emit("createCancelHandle");
      }
    },
    //重置表单
    resetForm() {
      this.userMenberList = [];
      this.userMembenNames = [];
      this.selecteTagsList = [];
      this.codeForm.qrType = "1";
      this.codeForm.userList = [];
      this.codeForm.tagIdList = [];
      this.codeForm.sceneName = "";
      this.codeForm.welcomeId = null;
      this.codeForm.skipVerify = true;
      this.codeForm.welcomeContent = "";
      this.codeForm.resourceVos = [];
      this.codeForm.linkVo = null;
      // this.welcomeClearBtnShow = false
      // this.welcomeAreaEditable = false
      this.upLoadData = {
        content: "",
        resourceVos: [],
        sopLink: null,
      };
    },
    //确认
    confirmHandle() {
      if (this.codeForm.userList.length == 0) {
        this.$message.warning("请先选择使用人员再生成活码");
      } else {
        let tagIdList = [];
        //标签
        if (this.selecteTagsList.length > 0) {
          this.selecteTagsList.map((v) => {
            tagIdList.push(v.tagId);
          });
        }
        this.codeForm.tagIdList = tagIdList;
        this.saveActiveCode();
      }
    },
    //新建、编辑接口
    saveActiveCode() {
      if (this.codeForm.qrType == "1") {
        this.$confirm(
          `二维码${this.editData == null ? "生成" : "更新"}中(批量单人${
            this.editData == null ? "生成" : "更新"
          }时间较长，不支持直接下载)`,
          "",
          {
            confirmButtonText: "确定",
            center: true,
            showCancelButton: false,
            iconClass: "el-icon-warning",
          }
        )
          .then(() => {})
          .catch(() => {});
      }
      if (this.editData != null) {
        editActiveCode(
          this.editData.qrId,
          this.codeForm,
          localStorage.getItem("Authorization")
        )
          .then((res) => {
            if (res.error.code == 200) {
              this.$emit("createSuccess", res.data, "更新成功！");
              this.resetForm();
            }
          })
          .catch((err) => {});
      } else {
        createActiveCode(this.codeForm, localStorage.getItem("Authorization"))
          .then((res) => {
            if (res.error.code == 200) {
              this.$emit(
                "createSuccess",
                res.data,
                "新建成功！",
                this.codeForm.userList
              );
              this.resetForm();
            }
          })
          .catch((err) => {});
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  /deep/.el-dialog__header {
    padding: 28px 32px 20px;
    .el-dialog__title {
      font-size: 16px;
      font-weight: bold;
    }
  }
  /deep/ .el-dialog__body {
    padding: 0px 24px 20px 32px;
  }
  /deep/ .el-dialog__footer {
    text-align: right;
    padding: 0 26px 20px;
  }
  /deep/.el-form-item {
    margin-bottom: 12px;
    .el-form-item__label {
      vertical-align: middle;
      float: left;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.9);
      font-weight: 500;
      line-height: 40px;
      padding: 0;
      box-sizing: border-box;
      -moz-text-align-last: justify;
      text-align-last: justify;
      text-align: justify;
      position: relative;
    }
    .my-label {
      -moz-text-align-last: justify;
      text-align-last: justify;
      text-align: justify;
      position: relative;
    }
    .el-form-item__content {
      margin-left: 78px !important;
    }
  }
  /deep/.el-form-item.is-required:not(.is-no-asterisk)
    > .el-form-item__label:before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
    position: absolute;
    left: -10px;
  }
  /deep/ .el-tags-wrap {
    .el-form-item__content {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      max-height: 110px;
      overflow: auto;
      min-height: 40px;
      line-height: 150%;
      .el-tag {
        margin: 2px 4px;
      }
    }
    .tags-btn {
      padding: 0;
    }
  }
  .welcome-form-item {
    position: relative;
    .welcome-clear {
      position: absolute;
      right: 5px;
      top: 5px;
      color: #909399;
      cursor: pointer;
    }
    .welcome-clear:hover {
      color: #000;
    }
  }
  .welcome-input {
    /deep/ .el-textarea__inner {
      padding-right: 50px;
    }
    /deep/ .el-input__count {
      height: 14px;
      line-height: 14px;
    }
  }
}
</style>
